import { render } from "./Detail.vue?vue&type=template&id=59d97eaa&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=59d97eaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59d97eaa"

export default script